<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <div>用户编辑</div>
                </div>

                <div class="admin_main_block_right">
                    <div><el-button icon="el-icon-back" @click="$router.go(-1)">返回</el-button></div>
                </div>
            </div>

            <div class="admin_form_main">
                <el-form  label-width="100px" ref="info" :model="info">
                    <el-form-item label="昵称" prop="F_VR_NIC"><el-input  readonly v-model="info.F_VR_NIC"></el-input></el-form-item>
                    <el-form-item label="手机号" prop="phone" ><el-input type="number" maxLength="11" readonly  v-model="info.phone" ></el-input></el-form-item>
                    <el-form-item label="头像" prop="thumb">
                      <img v-if="info.F_VR_TOUX" :src="info.F_VR_TOUX" class="avatar-upload">
                    </el-form-item>
                    <el-form-item label="备注" prop="remark" :rules="[{required:true,message:'备注不能为空',trigger: 'blur' }]"><el-input type="textarea"  placeholder="用户申请注销，七天确认无误，准予注销" v-model="info.remark"></el-input></el-form-item>

                    <el-form-item label="审核状态" prop="status">
                        <el-radio-group v-model="info.status">
                            <el-radio :label="2">确认注销</el-radio>
                            <el-radio :label="3">注销驳回</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="短信通知" prop="sms">
                        <el-radio-group v-model="info.sms">
                            <el-radio :label="1">暂不短信通知</el-radio>
                            <el-radio :label="2">发送通知短信</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('info')">提交</el-button>
                        <el-button @click="resetForm('info')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          edit_id:0,
          info:{},
          roles_list:[],
          roles:[],
          upload_headers:{},
      };
    },
    watch: {},
    computed: {},
    methods: {
        resetForm:function(e){
            this.$refs[e].resetFields();
        },
        submitForm:function(e){
            let _this = this;

            // 验证表单
            this.$refs[e].validate(function(res){
                if(res){
                    //  判断是Add 或者 Edit
                    let url = _this.$api.stateLogoutStatus;
                  // eslint-disable-next-line no-console
                    console.log(_this.info)
                    // Http 请求
                    _this.$post(url, {id: _this.info.id, remark: _this.info.remark, sms: _this.info.sms, status: _this.info.status, }).then(function(res){
                        if(res.code == 200){
                            _this.$message.success("提交成功");
                            _this.$router.go(-1);
                        }else{
                            _this.$message.error("提交失败");
                        }
                    });
                }
            });
        },
        get_users_info:function(){
            let _this = this;
            this.$get(this.$api.editStoreList+this.edit_id).then(function(res){
                _this.info = res.data['info'];
            })
        }
    },
    created() {
        this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到
        // 判断是否是编辑
        if(!this.$isEmpty(this.$route.params.id)){
            this.edit_id = this.$route.params.id;
        }
        if(this.edit_id>0){
            this.get_users_info();
        }
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>

</style>